import * as React from 'react';
import InfoIcon from '../Icons/InfoIcon/InfoIcon';
import { DataTest } from '../../utilities/testAutomation';

const Parser = require('html-react-parser');

interface TooltipProps extends DataTest {
  content: string;
}

const Tooltip = ({
  content,
  dataTest,
}: TooltipProps) => (
  <div className="tooltip-wrapper" {...dataTest}>
    <div className="i-icon">
      <InfoIcon />
      <div className="popover-content">
        <div className="triangle" />
        {Parser(content)}
      </div>
    </div>
  </div>
);

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.tsx